import { UseQueryOptions } from '@tanstack/react-query';
import { AuthUtils } from 'src/services/Auth/Auth.utils';

type UseQueryOptionsObject<TQueryFnData = unknown, TError = unknown> = Omit<
  UseQueryOptions<TQueryFnData, TError>,
  'queryKey' | 'queryFn'
>;

type QueryOptionsObject = Omit<UseQueryOptions<any, any, any, any>, 'queryKey' | 'queryFn'>;

type OptionsObject = {
  auth?: boolean;
} & QueryOptionsObject;

type DefaultOptionsFn = (options?: OptionsObject) => QueryOptionsObject;

/**
 * Default options for queries.
 *
 * Note: Global caching, retry, and refetch settings are now configured in
 * reactQueryClient.ts. This function only handles auth-specific logic.
 *
 * Global defaults (from reactQueryClient.ts):
 * - staleTime: 30 seconds
 * - cacheTime: 5 minutes
 * - retry: 3 times with exponential backoff (1s → 2s → 4s)
 * - refetchOnWindowFocus: false (disabled to prevent API storms in mobile WebViews)
 * - refetchOnReconnect: 'always'
 */
const defaultOptions: DefaultOptionsFn = (options = { auth: false }) => {
  const { auth, ...rest } = options;

  return {
    // Auth-specific: disable query if auth token is expired
    enabled: auth ? !AuthUtils.isExpired() : true,
    // Spread any additional options passed by individual queries
    ...(rest ?? {}),
  };
};

export type { UseQueryOptionsObject };
export { defaultOptions };
